import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  LOCALE_ID,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslocoService, provideTransloco } from '@jsverse/transloco';
import { AbstractSecurityStorage, authInterceptor, provideAuth } from 'angular-auth-oidc-client';
import { provideMatomo, withRouter, withRouterInterceptors } from 'ngx-matomo-client';
import { provideToastr } from 'ngx-toastr';

import { AppComponent } from './app/app.component';
import { ROUTES } from './app/routes';
import { httpErrorInterceptor } from './app/shared/interceptors/http-error.interceptor';
import { fullUrlInterceptor } from './app/shared/interceptors/matomo.interceptor';
import { AuthnStorageService } from './app/shared/services/authn-storage.service';
import { TranslocoHttpLoader, appInitializerFactory } from './app/shared/transloco-loader';
import { environment } from './environments/environment';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors([httpErrorInterceptor, authInterceptor()])),
    provideRouter(ROUTES, withComponentInputBinding()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideToastr(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideTransloco({
      config: {
        availableLangs: ['en', 'de'],
        defaultLang: 'de',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideAuth({
      config: environment.auth.config,
    }),
    { provide: AbstractSecurityStorage, useClass: AuthnStorageService },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslocoService],
      multi: true,
    },
    DatePipe,
    { provide: LOCALE_ID, useValue: 'de' },
    provideMatomo(
      {
        siteId: environment.matomoId,
        trackerUrl: 'https://analytics.apps.axpo.com/',
      },
      withRouter(),
      withRouterInterceptors([fullUrlInterceptor]),
    ),
  ],
};

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
